import React from "react";
import { Link } from "react-router-dom";
import { NewsItem } from "../types/types";
import { useLanguage } from "../context/LanguageContext";
import { getTranslation } from "../utils/translations";

interface NewsCardProps {
  news: NewsItem;
  imageHeight?: string;
}

const NewsCard: React.FC<NewsCardProps> = ({ news, imageHeight = "h-64" }) => {
  const { language } = useLanguage();
  
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-custom hover:shadow-lg transition duration-300">
      <Link to={`/news/${news.id}`} className="block overflow-hidden">
        <div className={`${imageHeight} overflow-hidden`}>
          <img
            src={news.image}
            alt={news.title}
            className="w-full h-full object-cover hover:scale-105 transition duration-500"
          />
        </div>
      </Link>
      <div className="p-6">
        <div className="text-mauritania-gold font-semibold mb-2">
          {news.date}
        </div>
        <Link to={`/news/${news.id}`}>
          <h3 className="text-xl font-bold text-mauritania-green-dark mb-3 hover:text-mauritania-green transition duration-300">
            {news.title}
          </h3>
        </Link>
        <p className="text-gray-600 mb-4">{news.excerpt}</p>
        <Link
          to={`/news/${news.id}`}
          className="text-mauritania-green font-semibold hover:text-mauritania-green-dark transition duration-300"
        >
          {getTranslation("readMore", language)}
        </Link>
      </div>
    </div>
  );
};

export default NewsCard;
